import useAddressSuggestions from '../../hooks/useAddressSuggestions'
import React, { useState, useEffect, useRef } from 'react'
import { TextField, Box, Autocomplete, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import filterStore from '../../stores/filterStore'
import { config } from '../../config'
import requestStore from '../../stores/requestStore'

import logger from '../../utils/logger'
import i18nStore from '../../stores/i18nStore'

const AddressObject = observer(() => {
	const [address, setAddress] = useState(filterStore.addressText || '')
	const addressLookup = useAddressSuggestions()
	const { suggestions: addressSuggestions, loading: isLoading, open, setOpen, error: addressError } = addressLookup
	const inputRef = useRef(null);

	const handleAddressChange = value => {
		setAddress(value)
		filterStore.setAddressText(value)
		filterStore.resetAddressSelection()
		filterStore.setAddress(null)
		addressLookup.search(value)
	}

	const handleSuggestionClick = suggestion => {
		filterStore.setAddressText(suggestion.value)
		filterStore.setAddress(suggestion.data)
		filterStore.setIsAddressSelected(true);
		setAddress(suggestion.value);
		setOpen(false);
		addressLookup.clear();
	}

	return (
		<Box sx={{ position: 'relative' }}>
				{import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && <div onClick={() => logger.log('AddressObject Render')}>% AddressObject %</div>}

			<Autocomplete
				freeSolo
				filterOptions={options => options}
				open={open}
				onOpen={() => {
					if (addressSuggestions.length > 0) {
						setOpen(true);
					}
				}}
				onClose={() => setOpen(false)}
				options={addressSuggestions}
				getOptionLabel={option =>
					typeof option === 'string' ? option : option.value
				}
				value={address}
				loading={isLoading}
				loadingText='Загрузка...'
				noOptionsText={address.length > 3 ? 'Нет подходящих адресов' : 'Введите больше символов'}
				onChange={(event, newValue) => {
					if (newValue && typeof newValue !== 'string') {
						handleSuggestionClick(newValue)
					} else if (newValue === null) {
						handleAddressChange('');
					} else if (typeof newValue === 'string') {
						handleAddressChange(newValue);
						setOpen(false);
					}
				}}
				onInputChange={(event, newInputValue, reason) => {
					if (reason === 'input') {
						handleAddressChange(newInputValue);
					} else if (reason === 'clear'){
						handleAddressChange('');
					}
				}}
				renderInput={params => (
					<TextField
						{...params}
						ref={inputRef}
						label='Адрес'
						size='small'
						fullWidth
						sx={{ maxWidth: '500px' }}
						placeholder={`${i18nStore.currentCountry}  Выберите адрес из подсказок`}
						error={Boolean(addressError) || (address.length > 0 && !filterStore.isAddressSelected)}
						helperText={
							addressError || (address.length > 0 && !filterStore.isAddressSelected
								? 'Пожалуйста, выберите адрес из подсказок'
								: '')
						}
					/>
				)}
			/>
		</Box>
	)
})

export default AddressObject
